import { Box, Button, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import PageNotFoundIllustration from 'assets/404-error.svg';
import MotionContainer from 'components/animate/MotionContainer';
import { varBounce } from 'components/animate/variants';
import Page from 'components/Page/Page';

import useLocales from 'hooks/useLocales';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
    display: 'flex',
    minHeight: '100%',
    alignItems: 'center',
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(10),
}));

// ----------------------------------------------------------------------

const Page404: React.FunctionComponent = () => {
    const { translate } = useLocales();

    return (
        <RootStyle title={`404 ${translate('page_not_found')} | CodeAcademy Kids`}>
            <Container>
                <MotionContainer initial='initial'>
                    <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
                        <motion.div variants={varBounce().in}>
                            <Typography variant='h3' paragraph>
                                404 {translate('page_not_found')}!
                            </Typography>
                        </motion.div>
                        <Typography sx={{ color: 'text.secondary' }}>
                            {translate('page_not_found_description')}
                        </Typography>

                        <motion.div variants={varBounce().in}>
                            <Box
                                component='img'
                                src={PageNotFoundIllustration}
                                sx={{
                                    height: 260,
                                    my: { xs: 5, sm: 10 },
                                    mx: 'auto',
                                }}
                            />
                        </motion.div>

                        <Button to='/' size='large' variant='contained' component={RouterLink}>
                            {translate('go_to_home')}
                        </Button>
                    </Box>
                </MotionContainer>
            </Container>
        </RootStyle>
    );
};

export default Page404;
